import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import UserService from "services/UserService";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import { getSite } from "services/ConfigServices";
import {
  dtgenchauff, dttypeecl, dtnateclcirc, dtnateclloc, dtgenhotwat, dttypecvc,
  dtgencold, dttypechauff
} from "variables/lists/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";

import { batiment } from "variables/patrimoine.js";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function Equipments(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  // const [heating, setHeating] = useState(false);
  // const [cooling, setCooling] = useState(false);
  const [heatingproductiondevice, setHeatingproductiondevice] = useState("");
  const [heatingdistributiondevice, setHeatingdistributiondevice] = useState("");
  const [coolingproductiondevice, setCoolingproductiondevice] = useState("");
  const [coolingdistributiondevice, setCoolingdistributiondevice] = useState("");
  const [hotwaterdevice, setHotwaterdevice] = useState("");
  const [officenaturallighting, setOfficenaturallighting] = useState("");
  const [corridornaturallighting, setCorridornaturallighting] = useState("");
  const [lightingdevice, setLightingdevice] = useState("");
  const [elavatorcount, setElavatorcount] = useState("");
  const [levelcount, setLevelcount] = useState("");
  const [capacity, setCapacity] = useState("");
  const [escalatorfulltime, setEscalatorfulltime] = useState("");
  const [escalatordetection, setEscalatordetection] = useState("");
  const [mecsidewalkfulltime, setMecsidewalkfulltime] = useState("");
  const [mecsidewalkdetection, setMecsidewalkdetection] = useState("");

  // const handleHeatingChange = (event) => {
  //   setHeating(!heating);
  // };
  // const handleCoolingChange = (event) => {
  //   setCooling(!cooling);
  // };
  const handleHeatingproductiondeviceChange = (event) => { setHeatingproductiondevice(event.target.value); };
  const handleHeatingdistributiondeviceChange = (event) => { setHeatingdistributiondevice(event.target.value); };
  const handleCoolingproductiondeviceChange = (event) => { setCoolingproductiondevice(event.target.value); };
  const handleCoolingdistributiondeviceChange = (event) => { setCoolingdistributiondevice(event.target.value); };
  const handleHotwaterdeviceChange = (event) => { setHotwaterdevice(event.target.value); };
  const handleOfficenaturallightingChange = (event) => { setOfficenaturallighting(event.target.value); };
  const handleCorridornaturallightingChange = (event) => { setCorridornaturallighting(event.target.value); };
  const handleLightingdeviceChange = (event) => { setLightingdevice(event.target.value); };
  const handleElavatorcountChange = (event) => { setElavatorcount(event.target.value); };
  const handleLevelcountChange = (event) => { setLevelcount(event.target.value); };
  const handleCapacityChange = (event) => { setCapacity(event.target.value); };
  const handleEscalatorfulltimeChange = (event) => { setEscalatorfulltime(event.target.value); };
  const handleEscalatordetectionChange = (event) => { setEscalatordetection(event.target.value); };
  const handleMecsidewalkfulltimeChange = (event) => { setMecsidewalkfulltime(event.target.value); };
  const handleMecsidewalkdetectionChange = (event) => { setMecsidewalkdetection(event.target.value); };


  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "equipments.tertiarybill"),
        {
          // heating,
          // cooling,
          heatingproductiondevice,
          heatingdistributiondevice,
          coolingproductiondevice,
          coolingdistributiondevice,
          hotwaterdevice,
          officenaturallighting,
          corridornaturallighting,
          lightingdevice,
          elavatorcount,
          levelcount,
          capacity,
          escalatorfulltime,
          escalatordetection,
          mecsidewalkfulltime,
          mecsidewalkdetection,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "equipments.tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        // setHeating(res.data.detail.equipments?.tertiarybill?.heating);
        // setCooling(res.data.detail.equipments?.tertiarybill?.cooling);
        setHeatingproductiondevice(res.data.detail.equipments?.tertiarybill?.heatingproductiondevice);
        setHeatingdistributiondevice(res.data.detail.equipments?.tertiarybill?.heatingdistributiondevice);
        setCoolingproductiondevice(res.data.detail.equipments?.tertiarybill?.coolingproductiondevice);
        setCoolingdistributiondevice(res.data.detail.equipments?.tertiarybill?.coolingdistributiondevice);
        setHotwaterdevice(res.data.detail.equipments?.tertiarybill?.hotwaterdevice);
        setOfficenaturallighting(res.data.detail.equipments?.tertiarybill?.officenaturallighting);
        setCorridornaturallighting(res.data.detail.equipments?.tertiarybill?.corridornaturallighting);
        setLightingdevice(res.data.detail.equipments?.tertiarybill?.lightingdevice);
        setElavatorcount(res.data.detail.equipments?.tertiarybill?.elavatorcount);
        setLevelcount(res.data.detail.equipments?.tertiarybill?.levelcount);
        setCapacity(res.data.detail.equipments?.tertiarybill?.capacity);
        setEscalatorfulltime(res.data.detail.equipments?.tertiarybill?.escalatorfulltime);
        setEscalatordetection(res.data.detail.equipments?.tertiarybill?.escalatordetection);
        setMecsidewalkfulltime(res.data.detail.equipments?.tertiarybill?.mecsidewalkfulltime);
        setMecsidewalkdetection(res.data.detail.equipments?.tertiarybill?.mecsidewalkdetection);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ margin: "1.3rem 0rem" }}>
            {/* <div>
              <CustomSwitch
                disabled={!realestateupdate}
                inputTitle={batiment.equipments.tertiarybill.heating}
                checkedState={heating}
                handleSwitchChange={handleHeatingChange}
              />
            </div>
            {heating ?
              <> */}
                <div>
                  <CustomSelect
                    inputTitle={batiment.equipments.tertiarybill.heatingproductiondevice}
                    selectValue={heatingproductiondevice}
                    handleSelectValueChange={handleHeatingproductiondeviceChange}
                    data={dtgenchauff}
                    disabled={!realestateupdate}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={batiment.equipments.tertiarybill.heatingdistributiondevice}
                    selectValue={heatingdistributiondevice}
                    handleSelectValueChange={handleHeatingdistributiondeviceChange}
                    data={dttypechauff}
                    disabled={!realestateupdate}
                  />
                </div>
              {/* </> : <></>} */}
            {/* <div>
              <CustomSwitch
                disabled={!realestateupdate}
                inputTitle={batiment.equipments.tertiarybill.cooling}
                checkedState={cooling}
                handleSwitchChange={handleCoolingChange}
              />
            </div>
            {cooling ?
              <> */}
                <div>
                  <CustomSelect
                    inputTitle={batiment.equipments.tertiarybill.coolingproductiondevice}
                    selectValue={coolingproductiondevice}
                    handleSelectValueChange={handleCoolingproductiondeviceChange}
                    data={dtgencold}
                    disabled={!realestateupdate}
                  />
                </div>
{/* 
              </> : <></>} */}
            <div>
              <CustomSelect
                inputTitle={batiment.equipments.tertiarybill.coolingdistributiondevice}
                selectValue={coolingdistributiondevice}
                handleSelectValueChange={handleCoolingdistributiondeviceChange}
                data={dttypecvc}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.equipments.tertiarybill.hotwaterdevice}
                selectValue={hotwaterdevice}
                handleSelectValueChange={handleHotwaterdeviceChange}
                data={dtgenhotwat}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.equipments.tertiarybill.officenaturallighting}
                selectValue={officenaturallighting}
                handleSelectValueChange={handleOfficenaturallightingChange}
                data={dtnateclloc}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.equipments.tertiarybill.corridornaturallighting}
                selectValue={corridornaturallighting}
                handleSelectValueChange={handleCorridornaturallightingChange}
                data={dtnateclcirc}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.equipments.tertiarybill.lightingdevice}
                selectValue={lightingdevice}
                handleSelectValueChange={handleLightingdeviceChange}
                data={dttypeecl}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.elavatorcount}
                intInput={elavatorcount}
                handleIntInputChange={handleElavatorcountChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.levelcount}
                intInput={levelcount}
                handleIntInputChange={handleLevelcountChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.capacity}
                intInput={capacity}
                handleIntInputChange={handleCapacityChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.escalatorfulltime}
                intInput={escalatorfulltime}
                handleIntInputChange={handleEscalatorfulltimeChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.escalatordetection}
                intInput={escalatordetection}
                handleIntInputChange={handleEscalatordetectionChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.mecsidewalkfulltime}
                intInput={mecsidewalkfulltime}
                handleIntInputChange={handleMecsidewalkfulltimeChange}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <IntInput
                inputTitle={batiment.equipments.tertiarybill.mecsidewalkdetection}
                intInput={mecsidewalkdetection}
                handleIntInputChange={handleMecsidewalkdetectionChange}
                disabled={!realestateupdate}
              />
            </div>
          </div>

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
